import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  bls: { value: null, matchMode: FilterMatchMode.CONTAINS },
  consignatarios: { value: null, matchMode: FilterMatchMode.CONTAINS },
  playaActual: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viaje: { value: null, matchMode: FilterMatchMode.CONTAINS },
  llegada: { value: null, matchMode: FilterMatchMode.DATE_IS },
  playaDevolucion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaLiberadoHasta: { value: null, matchMode: FilterMatchMode.DATE_IS },
  fechaRecibirHasta: { value: null, matchMode: FilterMatchMode.DATE_IS },
  estadoLiberacion: { value: null, matchMode: FilterMatchMode.EQUALS },
};
